import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "accessCode",
  class: "form-label"
}, "Access Code", -1)
const _hoisted_4 = ["readonly"]
const _hoisted_5 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "emailAddress",
  class: "form-label"
}, "Email Address", -1)
const _hoisted_8 = ["readonly"]
const _hoisted_9 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_10 = { class: "mb-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "firstName",
  class: "form-label"
}, "First Name", -1)
const _hoisted_12 = ["readonly"]
const _hoisted_13 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_14 = { class: "mb-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "lastName",
  class: "form-label"
}, "Last Name", -1)
const _hoisted_16 = ["readonly"]
const _hoisted_17 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_18 = { class: "form-checkbox ms-2 me-3" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "form-icon" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2 form-label" }, "Send Email Invite", -1)
const _hoisted_22 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Add Employee ")

import { Ref, ref, watch } from "vue";
import { getFunctions } from "firebase/functions";
import { ValidationError, validationMessage } from "@/model/validation-error";
import ModalView from "@/components/ModalView.vue";
import { Organisation, ValidationType } from "@/model/organisation";
import { ApiService } from "@/api-service";
import { Employee } from "@/model/employee";
import { AccessCode } from "@/utilties/access-code-gen";


export default /*#__PURE__*/_defineComponent({
  props: {
    isVisible: { type: Boolean },
    validationType: null,
    organisation: null
  },
  emits: ["hide-modal"],
  setup(__props: any, { emit }) {

const props = __props as {
  isVisible: boolean;
  validationType: ValidationType;
  organisation: Organisation;
}

let accessCode: Ref<string | null> = ref(null);
let accessCodeError: Ref<string | null> = ref(null);

let firstName: Ref<string | null> = ref(null);
let firstNameError: Ref<string | null> = ref(null);

let lastName: Ref<string | null> = ref(null);
let lastNameError: Ref<string | null> = ref(null);

let emailAddress: Ref<string | null> = ref(null);
let emailAddressError: Ref<string | null> = ref(null);

let sendEmailInvite: Ref<boolean> = ref(false);

let loading: Ref<boolean> = ref(false);





const apiService = new ApiService(getFunctions());

async function createEmployee() {
  let employeeId: string | null;
  switch (props.validationType) {
    case ValidationType.email:
      employeeId = emailAddress.value;
      break;
    case ValidationType.idCode:
      employeeId = accessCode.value;
      break;
  }

  if (employeeId == null || employeeId == "") {
    switch (props.validationType) {
      case ValidationType.email:
        emailAddressError.value = "Required";
        break;
      case ValidationType.idCode:
        accessCodeError.value = "Required";
        break;
    }
  } else {
    loading.value = true;
    await apiService
      .createEmployees(props.organisation.id, [
        new Employee(
          employeeId,
          firstName.value,
          lastName.value,
          emailAddress.value,
          true,
          null,
          false
        ),
      ])
      .then(() => {
        if (
          sendEmailInvite.value &&
          emailAddress.value != null &&
          emailAddress.value != ""
        ) {
          apiService.inviteEmployees(
            props.organisation.id,
            props.organisation.name,
            [
              {
                employeeId: employeeId!,
                emailAddress: emailAddress.value,
                firstName: firstName.value,
              },
            ]
          );
        }
      })
      .then(() => {
        emit("hide-modal");
      })
      .catch((error) => {
        console.log("Failed to create employees", error);
        if (error.code == "functions/already-exists") {
          accessCodeError.value = "User already exists";
        } else if (error.details) {
          let validationErrors = error.details as ValidationError[];
          for (let validationError of validationErrors) {
            switch (validationError.field) {
              case "employeeId": {
                switch (props.validationType) {
                  case ValidationType.email:
                    emailAddressError.value = validationMessage(
                      validationError.reason
                    );
                    break;
                  case ValidationType.idCode:
                    accessCodeError.value = validationMessage(
                      validationError.reason
                    );
                    break;
                }
                break;
              }
            }
          }
        }
      });
    loading.value = false;
  }
}

watch(
  () => props.isVisible,
  (visible: boolean) => {
    if (visible) {
      accessCode.value = AccessCode.generate(6);
      accessCodeError.value = null;
      firstName.value = null;
      firstNameError.value = null;
      lastName.value = null;
      lastNameError.value = null;
      emailAddress.value = null;
      emailAddressError.value = null;
      sendEmailInvite.value = false;
    }
  }
);

watch(
  () => accessCode.value,
  () => {
    accessCodeError.value = null;
  }
);
watch(
  () => emailAddress.value,
  () => {
    emailAddressError.value = null;
  }
);
watch(
  () => firstName.value,
  () => {
    firstNameError.value = null;
  }
);
watch(
  () => lastName.value,
  () => {
    lastNameError.value = null;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalView, {
    "is-visible": __props.isVisible,
    onHideModal: _cache[9] || (_cache[9] = ($event: any) => (emit('hide-modal')))
  }, {
    header: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn-close", { disabled: _unref(loading) }]),
        "data-bs-dismiss": "modal",
        "aria-label": "Close"
      }, null, 2)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (__props.validationType === _unref(ValidationType).idCode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _unref(accessCodeError) }]),
                onInput: _cache[0] || (_cache[0] = () => (_isRef(accessCode) //@ts-ignore
 ? accessCode.value = _unref(accessCode).toUpperCase() : accessCode = _unref(accessCode).toUpperCase())),
                id: "accessCode",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(accessCode) ? (accessCode).value = $event : accessCode = $event)),
                readonly: _unref(loading)
              }, null, 42, _hoisted_4), [
                [_vModelText, _unref(accessCode)]
              ]),
              (_unref(accessCodeError) != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(accessCodeError)), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "email",
            class: _normalizeClass(["form-control", { 'is-invalid': _unref(emailAddressError) }]),
            id: "emailAddress",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(emailAddress) ? (emailAddress).value = $event : emailAddress = $event)),
            readonly: _unref(loading)
          }, null, 10, _hoisted_8), [
            [_vModelText, _unref(emailAddress)]
          ]),
          (_unref(emailAddressError) != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(emailAddressError)), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: _normalizeClass(["form-control", { 'is-invalid': _unref(firstNameError) }]),
            id: "firstName",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(firstName) ? (firstName).value = $event : firstName = $event)),
            readonly: _unref(loading)
          }, null, 10, _hoisted_12), [
            [_vModelText, _unref(firstName)]
          ]),
          (_unref(firstNameError) != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(firstNameError)), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: _normalizeClass(["form-control", { 'is-invalid': _unref(lastNameError) }]),
            id: "lastName",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(lastName) ? (lastName).value = $event : lastName = $event)),
            readonly: _unref(loading)
          }, null, 10, _hoisted_16), [
            [_vModelText, _unref(lastName)]
          ]),
          (_unref(lastNameError) != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(lastNameError)), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("label", _hoisted_18, [
          _withDirectives(_createElementVNode("input", {
            disabled: _unref(emailAddress) == null || _unref(emailAddress) === '',
            type: "checkbox",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(sendEmailInvite) ? (sendEmailInvite).value = $event : sendEmailInvite = $event)),
            onChange: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
            onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
          }, null, 40, _hoisted_19), [
            [_vModelCheckbox, _unref(sendEmailInvite)]
          ]),
          _hoisted_20,
          _hoisted_21
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn btn-primary", { disabled: _unref(loading) }]),
        onClick: _cache[8] || (_cache[8] = ($event: any) => (createEmployee()))
      }, [
        (_unref(loading))
          ? (_openBlock(), _createElementBlock("span", _hoisted_22))
          : _createCommentVNode("", true),
        _hoisted_23
      ], 2)
    ]),
    _: 1
  }, 8, ["is-visible"]))
}
}

})